var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHutAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75061 9.0357C2.27618 9.4262 2 10.0174 2 10.6425V19.9423C2 21.0787 2.89543 22 4 22H9V17.8845C9 16.1798 10.3431 14.7979 12 14.7979C13.6569 14.7979 15 16.1798 15 17.8845V22H20C21.1046 22 22 21.0787 22 19.9423V10.6425C22 10.0174 21.7238 9.4262 21.2494 9.0357L13.2494 2.45092C12.519 1.84969 11.481 1.84969 10.7506 2.45092L2.75061 9.0357Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHutAlt2);
export default __webpack_public_path__ + "static/media/hut-alt-2.5064791663a42a35b07d6848b8a25dad.svg";
export { ForwardRef as ReactComponent };